import React, { useEffect, useState } from "react";
import { Link, withRouter } from "react-router-dom";
import { reservasAPI, cobranzasAPI } from "../../../utils/funcionesAPI";
import {
  manejadorDeRespuesta,
  deJSAFechaAmericana,
} from "../../../utils/Tools";
import CuadroResumen from "../CuadroResumen";
import LoaderFormal from "../../Global/LoaderFormal";
import { toast, ToastContainer } from "react-toastify";
import NumberFormat from "react-number-format";

const Deposito = (props) => {
  const [cuentasEntidades, setCuentasEntidades] = useState([]);
  const [loaded, setLoaded] = useState(false);
  const [informeDeDeposito, setInformeDeDeposito] = useState({
    importe: 0,
    numeroCupon: 0,
    fechaDeposito: deJSAFechaAmericana(new Date()),
    tipoDeMovimiento: "D",
    cuentaEntidad: { idCuentaEntidad: "0" },
    sucursalDeposito: "",
    documento: "",
    titular: "",
    cuentaOrigen: "",
    reserva: {
      producto: {
        destino: {},
        moneda: {
          cotizacion: 1,
          codigoMoneda: "PES",
        },
      },
      charter: {},
    },
  });

  const token = sessionStorage.getItem("token");
  const user = sessionStorage.getItem("usuario");

  if (!token && !user) {
    props.history.push("/login");
  }

  const traerReservaPorNumero = (numeroReserva) => {
    const data = JSON.stringify({
      peticion: "traerReservaPorNumero",
      token: token,
      numeroReserva: numeroReserva,
    });
    setLoaded(true);
    reservasAPI(data).then((respuesta) => {
      setLoaded(false);
      if (manejadorDeRespuesta(props, respuesta)) {
        traerCuentasEntidades(respuesta.data.cabecera);
        setInformeDeDeposito({
          ...informeDeDeposito,
          reserva: respuesta.data,
        });
      }
    });
  };

  useEffect(() => {
    traerReservaPorNumero(props.match.params.nroReserva);
  }, [props.match.params.nroReserva]);

  const traerCuentasEntidades = (cabecera) => {
    const data = JSON.stringify({
      peticion: "cuentasEntidades",
      cabecera: cabecera,
      token: token,
    });
    cobranzasAPI(data).then((respuesta) => {
      if (manejadorDeRespuesta(props, respuesta))
        setCuentasEntidades(respuesta.data);
    });
  };

  const handleDepositoChange = (e) => {
    setInformeDeDeposito({
      ...informeDeDeposito,
      [e.target.name]: e.target.value,
    });
  };

  const handleImporteAPagarChange = (e) => {
    const numberWithoutDot = e.target.value.replaceAll(",", "");
    setInformeDeDeposito({
      ...informeDeDeposito,
      [e.target.name]: numberWithoutDot,
    });
  };

  const handleCuentaEntidadChange = (e) => {
    let idCuentaEntidad = e.target.value;
    let cuentaEntidad = { idCuentaEntidad: "0" };

    if (idCuentaEntidad !== "0") {
      cuentaEntidad = cuentasEntidades.find(
        (e) => e.idCuentaEntidad === idCuentaEntidad
      );
    }

    setInformeDeDeposito({
      ...informeDeDeposito,
      cuentaEntidad,
    });
  };
  /*
  const traerCuentaEntidadElegida = () => {
    if (informeDeDeposito.cuentaEntidad)
      return informeDeDeposito.cuentaEntidad.idCuentaEntidad;
  };
  */
  const handleInformarDepositoClick = (e) => {
    e.preventDefault();

    if (
      informeDeDeposito.tipoDeMovimiento === "D" &&
      informeDeDeposito.sucursalDeposito === ""
    ) {
      toast.info("Debes completar todos los campos", {
        position: toast.POSITION.BOTTOM_CENTER,
      });
      return;
    }

    if (
      informeDeDeposito.tipoDeMovimiento === "T" &&
      informeDeDeposito.cuentaOrigen === ""
    ) {
      toast.info(
        "Falta completar la cuenta de origen o correjir el formato. Solo se aceptan numero",
        {
          position: toast.POSITION.BOTTOM_CENTER,
        }
      );
      return;
    }

    if (
      informeDeDeposito.cuentaEntidad.idCuentaEntidad !== "0" &&
      informeDeDeposito.importe !== "" &&
      informeDeDeposito.numeroCupon !== "" &&
      informeDeDeposito.titular !== "" &&
      informeDeDeposito.documento !== "" &&
      informeDeDeposito.documento.length > 6
    ) {
      const data = JSON.stringify({
        peticion: "deposito",
        informeDeDeposito: informeDeDeposito,
        token: token,
      });
      setLoaded(true);
      cobranzasAPI(data).then((respuesta) => {
        setLoaded(false);
        if (manejadorDeRespuesta(props, respuesta)) {
          /*toast.success(respuesta.data, {
            position: toast.POSITION.BOTTOM_CENTER
          });*/
          toast.success(respuesta.data, {
            position: toast.POSITION.BOTTOM_CENTER,
            onClose: () => props.history.push("/panel-mis-reservas"),
          });
          //document.getElementById("formInformeDeposito").reset();
        }
      });
    } else {
      toast.info("Debes completar todos los campos", {
        position: toast.POSITION.BOTTOM_CENTER,
      });
    }
  };

  return (
    <section className="reservas">
      <div className="container-fluid">
        <div className="row">
          <h1>Informar Pago</h1>
          <hr />
          <LoaderFormal loaded={loaded} />
          <CuadroResumen reserva={informeDeDeposito.reserva} />

          <div className="content col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
            <div>
              <form
                id="formInformeDeposito"
                className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12"
              >
                <p className="labelForm">* Todos los datos son obligatorios.</p>
                <div className="form-group d-inline-block col-xl-4 col-lg-4 col-md-4 col-sm-12 col-12">
                  <label className="labelForm" htmlFor="tipoDeMovimiento">
                    Deposito / Transferencia
                  </label>
                  <select
                    className="form-control"
                    name="tipoDeMovimiento"
                    onChange={handleDepositoChange}
                  >
                    <option value="D">Deposito</option>
                    <option value="T">Transferencia</option>
                  </select>
                </div>

                <div className="form-group d-inline-block col-xl-4 col-lg-4 col-md-4 col-sm-12 col-12">
                  <label className="labelForm" htmlFor="exampleInputEmail1">
                    {informeDeDeposito.tipoDeMovimiento === "D"
                      ? "Nombre y Apellido Depositante"
                      : "Titular Cuenta Origen"}{" "}
                    *
                  </label>
                  <input
                    type="text"
                    name="titular"
                    className="form-control"
                    value={informeDeDeposito.titular}
                    placeholder="Titular de la cuenta origen"
                    required
                    onChange={handleDepositoChange}
                    aria-describedby="fechaDepositoHelp"
                  />
                </div>

                {informeDeDeposito.tipoDeMovimiento === "T" && (
                  <div className="form-group d-inline-block col-xl-4 col-lg-4 col-md-4 col-sm-12 col-12">
                    <label className="labelForm" htmlFor="exampleInputEmail1">
                      N Cuenta de Origen (sin guión)*
                    </label>
                    <input
                      type="number"
                      name="cuentaOrigen"
                      className="form-control"
                      value={informeDeDeposito.cuentaOrigen}
                      placeholder="N de cuenta de deposito"
                      required
                      onChange={handleDepositoChange}
                      aria-describedby="fechaDepositoHelp"
                    />
                  </div>
                )}

                <div className="form-group d-inline-block col-xl-4 col-lg-4 col-md-4 col-sm-12 col-12">
                  <label className="labelForm" htmlFor="exampleInputEmail1">
                    Documento Nacional de Identidad *
                  </label>
                  <input
                    type="number"
                    name="documento"
                    className="form-control"
                    value={informeDeDeposito.documento}
                    placeholder="Documento"
                    required
                    onChange={handleDepositoChange}
                    aria-describedby="fechaDepositoHelp"
                  />
                </div>

                <div className="form-group d-inline-block col-xl-4 col-lg-4 col-md-4 col-sm-12 col-12">
                  <label className="labelForm" htmlFor="exampleInputEmail1">
                    Fecha Deposito *
                  </label>
                  <input
                    type="date"
                    name="fechaDeposito"
                    className="form-control"
                    value={informeDeDeposito.fechaDeposito}
                    placeholder="Fecha Deposito"
                    required
                    onChange={handleDepositoChange}
                    aria-describedby="fechaDepositoHelp"
                  />
                </div>

                <div className="form-group d-inline-block col-xl-4 col-lg-4 col-md-4 col-sm-12 col-12">
                  <label className="labelForm" htmlFor="numeroCupon">
                    {informeDeDeposito.tipoDeMovimiento === "D"
                      ? "N° Cupon"
                      : "N° de Transacción"}{" "}
                    *
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    name="numeroCupon"
                    required
                    onChange={handleDepositoChange}
                    placeholder="N° Cupón"
                  />
                </div>

                <div className="form-group d-inline-block col-xl-4 col-lg-4 col-md-4 col-sm-12 col-12">
                  <label className="labelForm" htmlFor="banco">
                    Seleccionar cuenta *
                  </label>
                  <select
                    className="form-control"
                    name="banco"
                    onChange={handleCuentaEntidadChange}
                  >
                    <option value="0">Seleccionar Cuenta</option>
                    {cuentasEntidades.map((cuentaEntidad) => {
                      return (
                        <option
                          key={cuentaEntidad.idCuentaEntidad}
                          value={cuentaEntidad.idCuentaEntidad}
                        >
                          {cuentaEntidad.denominacion}
                        </option>
                      );
                    })}
                  </select>
                </div>

                <div className="form-group d-inline-block col-xl-4 col-lg-4 col-md-4 col-sm-12 col-12">
                  <label className="labelForm" htmlFor="importe">
                    Importe *
                  </label>
                  {/* <input
                    type="text"
                    inputmode="numeric"
                    pattern="[0-9]*"
                    className="form-control"
                    name="importe"
                    placeholder="Importe"
                    required
                    onChange={handleDepositoChange}
                  /> */}
                  <NumberFormat
                    placeholder="Importe"
                    className="form-control"
                    name="importe"
                    displayType={"input"}
                    thousandSeparator=","
                    allowNegative={false}
                    fixedDecimalScale={true}
                    decimalScale={2}
                    decimalSeparator="."
                    required
                    onChange={handleImporteAPagarChange}
                  />
                </div>

                {informeDeDeposito.tipoDeMovimiento === "D" && (
                  <div className="form-group d-inline-block col-xl-4 col-lg-4 col-md-4 col-sm-12 col-12">
                    <label className="labelForm" htmlFor="sucursalDeposito">
                      Sucursal *
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      name="sucursalDeposito"
                      placeholder="Sucursal"
                      required
                      onChange={handleDepositoChange}
                    />
                  </div>
                )}

                <p className="contenedorLinkInicio col-xl-3 col-lg-3 col-md-3 col-sm-12 col-12">
                  <input
                    className="botonInicio"
                    type="submit"
                    value="Informar"
                    onClick={handleInformarDepositoClick}
                  />
                </p>
              </form>
            </div>
            <div className="listado">
              <Link to="/panel-mis-reservas">Volver al Panel</Link>
            </div>
          </div>
        </div>
      </div>
      <ToastContainer />
    </section>
  );
};
//FC: el withRouter es para poder hacer un this.props.history.push('/')
export default withRouter(Deposito);



// WEBPACK FOOTER //
// ./src/components/MisReservas/Deposito/index.js